package tech.gensert.portal.common.model.enums

import kotlinx.serialization.Serializable

@Serializable
enum class Interval {
    month, year
}